import * as fromDatatype from '../datatype-library';

export interface bl_wf_project_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  key: fromDatatype.VarcharDatatypeInterface;
  default_assignee_guid: fromDatatype.GuidDataFieldInterface;
  lead_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  url: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  guid_category: fromDatatype.GuidDataFieldInterface;
  avatar_guid:fromDatatype.GuidDataFieldInterface; 
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wf_project_hdr_RowClass implements bl_wf_project_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  key: fromDatatype.VarcharDatatypeInterface;
  default_assignee_guid: fromDatatype.GuidDataFieldInterface;
  lead_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  url: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  guid_category: fromDatatype.GuidDataFieldInterface;
  avatar_guid:fromDatatype.GuidDataFieldInterface; 
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
}
